<template>
  <div class="annotation-controls-wrapper">
    <div class="annotation-controls">
      <v-row no-gutters justify="center">
        <v-col cols="5" lg="4">
          <annotation-file-management-button-collection
            :context="context"
            @downloadImage="downloadImage"
            @saveImage="saveImage"
            @resetImage="resetImage"
            @clearAnnotations="clearAnnotations"
            @printImage="openPrintPreview([currentBrowserImage])"/>
          <image-zoom-control
            :imgNotFound="imgNotFound"
            :img="displayImgObject"
            :imgIsLoading="imgIsLoading"
            :transform="transform"
            :isFlipped="isFlipped"
            :isFlipped90="isFlipped90"
            :size="zoomControlSize"
            :fit="zoomControlFit"
            height="150px"
            class="side-by-side-zoom-control-wrapper"
            @updateZoom="$emit('updateZoom', $event)"
            @updateCenter="$emit('updateCenter', $event)"/>
        </v-col>
        <v-col cols="7" lg="8" v-if="canAnnotate">
          <v-row no-gutters>
            <v-col cols="12" lg="6" order="1">
              <annotation-drawing-button-collection
                :context="context"
                :syncContext="syncContext"
                :annotationColor="annotationColor"
                :shapeFillColor="shapeFillColor"
                :isFlipped="isFlipped"
                @input="annotationModeButtonClick($event)"
                @setSize="updateTextSize"/>
            </v-col>
            <v-col cols="12"
              lg="6"
              order="4"
              order-lg="3">
              <annotation-calibrations-collection 
              :context="context"/>
            </v-col>
            <v-col cols="12" lg="6" order="2">
              <annotation-control-button-collection
                :context="context"
                :isFlipped="isFlipped"
                :isFlipped90="isFlipped90"
                @input="annotationModeButtonClick($event)"
                @flip="toggleFlipped"
                @flip90="toggleFlipped90"
                @fit="$emit('zoomToFit', $event)"
                @zoom="$emit('updateZoom', 1)"/>
              <annotation-grayscale-button-collection
                :context="context"
                :isFlipped="isFlipped"
                :oct="oct"
                :optos="optos"
                :grayscaleMode="grayscaleMode"
                :isDragLock="isDragLock"
                @input="toggleGrayscaleMode($event)"
                @annotationMode="annotationModeButtonClick($event)"
                @toggleMouseWheelZoom="toggleMouseWheelZoom()"
                @dragButtonClick="dragButtonClick()"/>
            </v-col>
            <v-col cols="12"
              lg="6"
              order="3"
              order-lg="4">
              <annotation-slider-collection
                :context="context"
                size="xSmall"
                :gamma="gamma"
                :contrast="contrast"
                :brightness="brightness"
                :lineWidth="annotationOptions"
                @updateBrightness="updateBrightness"
                @updateContrast="updateContrast"
                @updateGamma="updateGamma"/>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import imageZoomControl from "../imageBrowser/controls/ImageZoomControl";
import imageAnnotationHelper from "../mixins/ImageAnnotationHelper";
import annotationControlButtonCollection from "./controls/AnnotationControlButtonCollection";
import annotationDrawingButtonCollection from "./controls/AnnotationDrawingButtonCollection";
import annotationGrayscaleButtonCollection from "./controls/AnnotationGrayscaleButtonCollection";
import annotationCalibrationsCollection from "./controls/AnnotationCalibrationsCollection";
import annotationFileManagementButtonCollection from "./controls/AnnotationFileManagementButtonCollection";
import annotationSliderCollection from "./controls/AnnotationSliderCollection";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "sideBySideImageAnnotationControls",
  components: {
    imageZoomControl,
    annotationControlButtonCollection,
    annotationDrawingButtonCollection,
    annotationGrayscaleButtonCollection,
    annotationCalibrationsCollection,
    annotationFileManagementButtonCollection,
    annotationSliderCollection
  },
  props: [
    "zoomControlSize",
    "zoomControlFit",
    "transform",
    "context",
    "isLeft",
    "syncContext"
  ],
  mixins: [imageAnnotationHelper],
  computed: {
    ...mapGetters(["canAnnotate", "sideBySideCanSync"]),
    optos() {
      return this.isOptos;
    },
    oct() {
      return this.isOCT;
    }
  },
  methods: {
    ...mapActions(["openPrintPreview"])
  },
  watch: {
    annotationLineWidth: {
      handler() {
        if (this.activeAnnotation) this.lineWidthGenerateFlatImage();
      },
      deep: true
    },
    annotationTextSize() {
      this.generateFlatImage();
    }
  }
};
</script>